module.exports = __webpack_public_path__ + "assets/img/cd8ccc99b8c0cfc7e26332a4b31a2c36.png";